"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * ModalScreen renders behind the modal content and acts as the clickable
 * element that closes the modal when users click outside of the modal content
 *
 */
var ModalScreen = function ModalScreen(_ref) {
  var onClick = _ref.onClick;
  return _react.default.createElement("button", {
    type: "button",
    className: "ModalScreen absolute w-full cursor-default",
    style: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    },
    onClick: onClick,
    "aria-label": "Close modal"
  });
};

ModalScreen.propTypes = {
  onClick: _propTypes.default.func.isRequired
};
var _default = ModalScreen;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb21wb25lbnRzL01vZGFsL01vZGFsU2NyZWVuLmpzIl0sIm5hbWVzIjpbIk1vZGFsU2NyZWVuIiwib25DbGljayIsInRvcCIsInJpZ2h0IiwiYm90dG9tIiwibGVmdCIsInByb3BUeXBlcyIsIlByb3BUeXBlcyIsImZ1bmMiLCJpc1JlcXVpcmVkIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7O0FBQ0E7Ozs7QUFFQTs7Ozs7QUFNQSxJQUFNQSxXQUFXLEdBQUcsU0FBZEEsV0FBYztBQUFBLE1BQUdDLE9BQUgsUUFBR0EsT0FBSDtBQUFBLFNBQ2xCO0FBQ0UsSUFBQSxJQUFJLEVBQUMsUUFEUDtBQUVFLElBQUEsU0FBUyxFQUFDLDRDQUZaO0FBR0UsSUFBQSxLQUFLLEVBQUU7QUFBRUMsTUFBQUEsR0FBRyxFQUFFLENBQVA7QUFBVUMsTUFBQUEsS0FBSyxFQUFFLENBQWpCO0FBQW9CQyxNQUFBQSxNQUFNLEVBQUUsQ0FBNUI7QUFBK0JDLE1BQUFBLElBQUksRUFBRTtBQUFyQyxLQUhUO0FBSUUsSUFBQSxPQUFPLEVBQUVKLE9BSlg7QUFLRSxrQkFBVztBQUxiLElBRGtCO0FBQUEsQ0FBcEI7O0FBVUFELFdBQVcsQ0FBQ00sU0FBWixHQUF3QjtBQUN0QkwsRUFBQUEsT0FBTyxFQUFFTSxtQkFBVUMsSUFBVixDQUFlQztBQURGLENBQXhCO2VBSWVULFciLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSBcInJlYWN0XCI7XG5pbXBvcnQgUHJvcFR5cGVzIGZyb20gXCJwcm9wLXR5cGVzXCI7XG5cbi8qKlxuICogTW9kYWxTY3JlZW4gcmVuZGVycyBiZWhpbmQgdGhlIG1vZGFsIGNvbnRlbnQgYW5kIGFjdHMgYXMgdGhlIGNsaWNrYWJsZVxuICogZWxlbWVudCB0aGF0IGNsb3NlcyB0aGUgbW9kYWwgd2hlbiB1c2VycyBjbGljayBvdXRzaWRlIG9mIHRoZSBtb2RhbCBjb250ZW50XG4gKlxuICovXG5cbmNvbnN0IE1vZGFsU2NyZWVuID0gKHsgb25DbGljayB9KSA9PiAoXG4gIDxidXR0b25cbiAgICB0eXBlPVwiYnV0dG9uXCJcbiAgICBjbGFzc05hbWU9XCJNb2RhbFNjcmVlbiBhYnNvbHV0ZSB3LWZ1bGwgY3Vyc29yLWRlZmF1bHRcIlxuICAgIHN0eWxlPXt7IHRvcDogMCwgcmlnaHQ6IDAsIGJvdHRvbTogMCwgbGVmdDogMCB9fVxuICAgIG9uQ2xpY2s9e29uQ2xpY2t9XG4gICAgYXJpYS1sYWJlbD1cIkNsb3NlIG1vZGFsXCJcbiAgLz5cbik7XG5cbk1vZGFsU2NyZWVuLnByb3BUeXBlcyA9IHtcbiAgb25DbGljazogUHJvcFR5cGVzLmZ1bmMuaXNSZXF1aXJlZCxcbn07XG5cbmV4cG9ydCBkZWZhdWx0IE1vZGFsU2NyZWVuO1xuIl19